import React from "react";

const PipeContext = React.createContext({
  mode: "chain",
});

export default PipeContext;
